import { Grid2, Typography } from "@mui/material";
import { LandingPageSection } from "../static-page-components/landing-page-section";
import { VideoCarousel } from "./video-carousel";
import { reorderVideosByRequestedPattern } from "./reorder-videos";

const VIMEO_REVIEW_BASE_URL =
  "https://vimeo.com/reviews/900d0541-58c8-4e7f-a056-2f0faa9ff953/videos";

const videos = [
  {
    id: "1171625633",
    title: "Designer Confessions: What Makes for the Best Relationship",
    thumbnail:
      "https://i.vimeocdn.com/video/2131192832-8bf8068df410aa286bf2d012c533a8d83b8e7a2d49c8c8317f714ae8d42818e4-d_640?region=us",
  },
  {
    id: "1171617548",
    title: "Designer Confessions: How Great Design Transforms the Way You Live",
    thumbnail:
      "https://i.vimeocdn.com/video/2131188002-1bde9de052e061e5d456ce1556fb0ab40b7786209047bdadf6517e8454d0a459-d_640?region=us",
  },
  {
    id: "1171606089",
    title: "Designer Confessions: Hire Us First",
    thumbnail:
      "https://i.vimeocdn.com/video/2131172604-0f8fd8d97301a6a4652fabbdd8cfe77bab776a00f81d1b9db081b7e83a427727-d_640?region=us",
  },
  {
    id: "1171597748",
    title:
      "Designer Confessions: Why Hiring an Interior Designer Could Actually Save you Money",
    thumbnail:
      "https://i.vimeocdn.com/video/2131175685-1fc3456ed42e377a3ee25410b0060eebfc36c7dd1acb678e989f801a2ff77736-d_640?region=us",
  },
  {
    id: "1171600384",
    title: "Designer Confessions: What to Really Look for in an Interior Designer",
    thumbnail:
      "https://i.vimeocdn.com/video/2131159543-16bdaeee207a2180337637a340680cfb795c4d8b32196f401c1a1df2c2c7cd57-d_640?region=us",
  },
  {
    id: "1171603549",
    title: "Designer Confessions: The Details Designers Notice",
    thumbnail:
      "https://i.vimeocdn.com/video/2131175331-56b97183664623dd6ecd8acf37a3e993cbed2cc95b52ce4709173f8b53648ff4-d_640?region=us",
  },
  {
    id: "1171587722",
    title: "Designer Confessions: Honesty, Humor & Client Conversations",
    thumbnail:
      "https://i.vimeocdn.com/video/2131148340-b55d1fcaf48d8889d5a4d638086cdbfc72fe70b27dcd5b35d13a4af8e4e140f6-d_640?region=us",
  },
  {
    id: "1171590179",
    title: "Designer Confessions: Good Design is Not Instant",
    thumbnail:
      "https://i.vimeocdn.com/video/2131146705-90855bc0bee57c98e618f41ef2e2862c7f8fe03414e6b86c35390b0d91bc03dd-d_640?region=us",
  },
  {
    id: "1171584798",
    title: "Designer Confessions: Preparing for a Home Design Project",
    thumbnail:
      "https://i.vimeocdn.com/video/2131138280-016c8946073fe3ad55d74032782e5fede466d7b69fe8cb9efef10c956464ee19-d_640?region=us",
  },
  {
    id: "1171245089",
    title: "Designer Confessions: Structure Must Proceed Beauty",
    thumbnail:
      "https://i.vimeocdn.com/video/2130685970-31382a477bd802993ecdfa17fe31e1adc13227f78d1b2ff57bed0f01eb124eeb-d_640?region=us",
  },
  {
    id: "1171127530",
    title: "Designer Confessions: Designing for How You Actually Live",
    thumbnail:
      "https://i.vimeocdn.com/video/2130681473-21f4c15e3092e155ac923a461463d0710f5c52f76158ce9abaaeddf32534323c-d_640?region=us",
  },
  {
    id: "1170838249",
    title: "Designer Confessions: So You Have Great Taste",
    thumbnail:
      "https://i.vimeocdn.com/video/2130679474-8b371c53fc516ffd30dbcdda5f1811d8a9b5f93fc6ca7926475664accc381203-d_640?region=us",
  },
].map(({ id, title, thumbnail }) => ({
  title,
  description: "",
  url: `${VIMEO_REVIEW_BASE_URL}/${id}`,
  videoBanner: thumbnail,
}));

const orderedVideos = reorderVideosByRequestedPattern(videos);

export const VideoSection = () => (
    <LandingPageSection sx={{ pb: { xs: 8, md: 8 }, pl: { xs: 4, md: 0 }, pr: { xs: 4, md: 0 } ,pt: { xs: 0, md: 8 }}}>
        <Grid2 container columns={12} >
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ textAlign: { xs: "justify", md: "center" } }}>
                <Typography variant="overline" className="text-purple" sx={{ textAlign: { xs: "left", md: "center" } }}>
                    DESIGNER CONFESSIONS
                </Typography>
                <Typography variant={"display2" as any}
                    component="h2"
                    className="text-center text-pink" sx={{ mb: {xs:2,md:3.5}, textAlign: { xs: "left", md: "center" } }}>
                    SPILLING THE TEA
                </Typography>
          <Typography variant="body1" className="contain-text" sx={{ mb: {xs:8,md:5}, fontSize:{xs: "20px", md: "25px"}, color: "#1C1C1C" }} 
          >
                    What it looks like behind the scenes in the world of a design professional and why they are worth every penny.
                </Typography>
            </Grid2>
        </Grid2>
        <VideoCarousel videos={orderedVideos} />
    </LandingPageSection>
); 
